import { createAllActions } from '@api/createRequestStore';
import { ENGAGEMENT_TYPE } from './reducer';

import * as types from './types';

export const init = () => ({
  type: types.INIT,
});

export const initChart = () => ({
  type: types.INIT_CHART,
});

export const resetChart = () => ({
  type: types.RESET_CHART,
});

export const setDefaultSlice = (defaultZoom, defaultBrush) => ({
  type: types.SET_DEFAULT_SLICE,
  defaultZoom,
  defaultBrush,
});

export const setSlice = (zoom, brush) => ({
  type: types.SET_SLICE,
  zoom,
  brush,
});


export const enableTableCompare = (flag) => ({
  type: types.ENABLE_TABLE_COMPARE,
  flag
});

export const resetSlice = () => ({
  type: types.RESET_SLICE,
});

export const setInterval = (interval: [string, string]) => ({
  type: types.SET_INTERVAL,
  interval,
});

export const injectSharedState = (state) => ({
  type: types.INJECT_SHARED_STATE,
  state,
});

export const switchZoomBrush = () => ({
  type: types.SWITCH_ZOOM_BRUSH,
});

export const setChartType = (chartType: 'line' | 'bar' | '') => ({
  type: types.SET_CHART_TYPE,
  chartType
});

export const toggleEngagementType = () => ({
  type: types.TOGGLE_ENGAGEMENT_TYPE,
});

export const setEngagementType = (engagementType: ENGAGEMENT_TYPE) => ({
  type: types.SET_ENGAGEMENT_TYPE,
  engagementType,
});

export const setBucket = (bucket: string) => ({
  type: types.SET_BUCKET,
  bucket,
});

export const fetchingInitData = () => ({
  type: types.FETCHING_INIT_DATA,
});

export const fetchingDataWhenZoomChange = () => ({
  type: types.FETCHING_DATA_WHEN_ZOOM_CHANGE,
});

export const fetchingDataOnCompareIntervalChange = () => ({
  type: types.FETCHING_DATA_ON_COMPARE_INTERVAL_CHANGE,
});

export const triggerTrendsChartCompare = checked => ({
  type: types.TRENDS_CHART_COMPARE_TRIGGER,
  checked,
});

const { init: initZoomRequest, fetching: fetchingZoom } = createAllActions(types.ZOOM_CHART_REQUEST_SCOPE);
const { init: initBrushRequest, fetching: fetchingBrush } = createAllActions(types.BRUSH_CHART_REQUEST_SCOPE);
const { init: initBrushCompareRequest, fetching: fetchingCompareBrush } = createAllActions(types.BRUSH_COMPARE_CHART_REQUEST_SCOPE);
const { init: initSecondaryRequest, fetching: fetchingSecondary } = createAllActions(types.SECONDARY_LINE_CHART_REQUEST_SCOPE);
const { init: initSecondaryCompareRequest, fetching: fetchingCompareSecondary } = createAllActions(types.SECONDARY_COMPARE_LINE_CHART_REQUEST_SCOPE);

export {
  initZoomRequest,
  initBrushRequest,
  initBrushCompareRequest,
  initSecondaryRequest,
  initSecondaryCompareRequest,
  fetchingZoom,
  fetchingBrush,
  fetchingCompareBrush,
  fetchingSecondary,
  fetchingCompareSecondary,
};
